import { render } from "./BuyingGeneralInfo.vue?vue&type=template&id=472cb8c6&scoped=true&ts=true"
import script from "./BuyingGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./BuyingGeneralInfo.vue?vue&type=script&lang=ts"

import "./BuyingGeneralInfo.vue?vue&type=style&index=0&id=472cb8c6&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472cb8c6"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QBtn,QCheckbox,QOptionGroup});
